import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 家庭数据
export function queryorghome () {
  return request({
    url: '/queryorghome',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建家庭
export function addorghome (data) {
  return request({
    url: '/addorghome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新家庭
export function updateorghome (data) {
  return request({
    url: '/updateorghome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除家庭
export function deleteorghome (data) {
  return request({
    url: '/deleteorghome',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 通过小区ids查询家庭
export function queryhomebycids (data) {
  return request({
    url: '/queryhomebycids',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/relation.js